module.exports = __webpack_public_path__ + "fonts/16267daf/proximanova-regularit-webfont.ttf";